exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inputTextComponent---YK-mY {\n  position: relative; }\n\n.inputText---Dt8ml {\n  height: 38px;\n  width: 100%;\n  padding-left: 13px;\n  padding-right: 30px;\n  border: none;\n  color: #8b8b8b;\n  font-size: 16px;\n  font-family: Poppins;\n  outline: none; }\n", ""]);

// exports
exports.locals = {
	"inputTextComponent": "inputTextComponent---YK-mY",
	"inputText": "inputText---Dt8ml"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/assign-course-conquest/styles/search.scss
// module id = 1116
// module chunks = 3